/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseMgmtOrderControllerOrder } from '../fn/order/get-many-base-mgmt-order-controller-order';
import { GetManyBaseMgmtOrderControllerOrder$Params } from '../fn/order/get-many-base-mgmt-order-controller-order';
import { getManyBaseMgmtOrderPendingGroupByMemberControllerMember } from '../fn/order/get-many-base-mgmt-order-pending-group-by-member-controller-member';
import { GetManyBaseMgmtOrderPendingGroupByMemberControllerMember$Params } from '../fn/order/get-many-base-mgmt-order-pending-group-by-member-controller-member';
import { getManyBaseMgmtOrdersShippedControllerShipping } from '../fn/order/get-many-base-mgmt-orders-shipped-controller-shipping';
import { GetManyBaseMgmtOrdersShippedControllerShipping$Params } from '../fn/order/get-many-base-mgmt-orders-shipped-controller-shipping';
import { GetManyMemberResponseDto } from '../models/get-many-member-response-dto';
import { GetManyOrderResponseDto } from '../models/get-many-order-response-dto';
import { GetManyShippingResponseDto } from '../models/get-many-shipping-response-dto';
import { getOneBaseMgmtOrderControllerOrder } from '../fn/order/get-one-base-mgmt-order-controller-order';
import { GetOneBaseMgmtOrderControllerOrder$Params } from '../fn/order/get-one-base-mgmt-order-controller-order';
import { getOneBaseMgmtOrdersShippedControllerShipping } from '../fn/order/get-one-base-mgmt-orders-shipped-controller-shipping';
import { GetOneBaseMgmtOrdersShippedControllerShipping$Params } from '../fn/order/get-one-base-mgmt-orders-shipped-controller-shipping';
import { GetOrdersToShipResponseDto } from '../models/get-orders-to-ship-response-dto';
import { mgmtOrderPickupControllerFindPickupPoint } from '../fn/order/mgmt-order-pickup-controller-find-pickup-point';
import { MgmtOrderPickupControllerFindPickupPoint$Params } from '../fn/order/mgmt-order-pickup-controller-find-pickup-point';
import { mgmtOrdersToShipControllerGetMany } from '../fn/order/mgmt-orders-to-ship-controller-get-many';
import { MgmtOrdersToShipControllerGetMany$Params } from '../fn/order/mgmt-orders-to-ship-controller-get-many';
import { mgmtOrdersToShipControllerPreprocess } from '../fn/order/mgmt-orders-to-ship-controller-preprocess';
import { MgmtOrdersToShipControllerPreprocess$Params } from '../fn/order/mgmt-orders-to-ship-controller-preprocess';
import { mgmtOrdersToShipControllerProcess } from '../fn/order/mgmt-orders-to-ship-controller-process';
import { MgmtOrdersToShipControllerProcess$Params } from '../fn/order/mgmt-orders-to-ship-controller-process';
import { mgmtOrdersToShipControllerValidate } from '../fn/order/mgmt-orders-to-ship-controller-validate';
import { MgmtOrdersToShipControllerValidate$Params } from '../fn/order/mgmt-orders-to-ship-controller-validate';
import { Order } from '../models/order';
import { PickupPointDto } from '../models/pickup-point-dto';
import { PreprocessOrdersToShipResponseDto } from '../models/preprocess-orders-to-ship-response-dto';
import { ProcessOrdersToShipResponseDto } from '../models/process-orders-to-ship-response-dto';
import { Shipping } from '../models/shipping';
import { updateOneBaseMgmtOrderControllerOrder } from '../fn/order/update-one-base-mgmt-order-controller-order';
import { UpdateOneBaseMgmtOrderControllerOrder$Params } from '../fn/order/update-one-base-mgmt-order-controller-order';

@Injectable({ providedIn: 'root' })
export class OrderApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtOrderPendingGroupByMemberControllerMember()` */
  static readonly GetManyBaseMgmtOrderPendingGroupByMemberControllerMemberPath = '/api/mgmt-orders/pending-group-by-member';

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtOrderPendingGroupByMemberControllerMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderPendingGroupByMemberControllerMember$Response(params?: GetManyBaseMgmtOrderPendingGroupByMemberControllerMember$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyMemberResponseDto>> {
    const obs = getManyBaseMgmtOrderPendingGroupByMemberControllerMember(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Members.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtOrderPendingGroupByMemberControllerMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderPendingGroupByMemberControllerMember(params?: GetManyBaseMgmtOrderPendingGroupByMemberControllerMember$Params, context?: HttpContext): Observable<GetManyMemberResponseDto> {
    const resp = this.getManyBaseMgmtOrderPendingGroupByMemberControllerMember$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyMemberResponseDto>): GetManyMemberResponseDto => r.body)
    );
  }

  /** Path part for operation `mgmtOrdersToShipControllerGetMany()` */
  static readonly MgmtOrdersToShipControllerGetManyPath = '/api/mgmt-orders/to-ship';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtOrdersToShipControllerGetMany()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtOrdersToShipControllerGetMany$Response(params?: MgmtOrdersToShipControllerGetMany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersToShipResponseDto>> {
    const obs = mgmtOrdersToShipControllerGetMany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtOrdersToShipControllerGetMany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtOrdersToShipControllerGetMany(params?: MgmtOrdersToShipControllerGetMany$Params, context?: HttpContext): Observable<GetOrdersToShipResponseDto> {
    const resp = this.mgmtOrdersToShipControllerGetMany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetOrdersToShipResponseDto>): GetOrdersToShipResponseDto => r.body)
    );
  }

  /** Path part for operation `mgmtOrdersToShipControllerPreprocess()` */
  static readonly MgmtOrdersToShipControllerPreprocessPath = '/api/mgmt-orders/to-ship/preprocess';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtOrdersToShipControllerPreprocess()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mgmtOrdersToShipControllerPreprocess$Response(params: MgmtOrdersToShipControllerPreprocess$Params, context?: HttpContext): Observable<StrictHttpResponse<PreprocessOrdersToShipResponseDto>> {
    const obs = mgmtOrdersToShipControllerPreprocess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtOrdersToShipControllerPreprocess$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mgmtOrdersToShipControllerPreprocess(params: MgmtOrdersToShipControllerPreprocess$Params, context?: HttpContext): Observable<PreprocessOrdersToShipResponseDto> {
    const resp = this.mgmtOrdersToShipControllerPreprocess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PreprocessOrdersToShipResponseDto>): PreprocessOrdersToShipResponseDto => r.body)
    );
  }

  /** Path part for operation `mgmtOrdersToShipControllerProcess()` */
  static readonly MgmtOrdersToShipControllerProcessPath = '/api/mgmt-orders/to-ship/process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtOrdersToShipControllerProcess()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mgmtOrdersToShipControllerProcess$Response(params: MgmtOrdersToShipControllerProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessOrdersToShipResponseDto>> {
    const obs = mgmtOrdersToShipControllerProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtOrdersToShipControllerProcess$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mgmtOrdersToShipControllerProcess(params: MgmtOrdersToShipControllerProcess$Params, context?: HttpContext): Observable<ProcessOrdersToShipResponseDto> {
    const resp = this.mgmtOrdersToShipControllerProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessOrdersToShipResponseDto>): ProcessOrdersToShipResponseDto => r.body)
    );
  }

  /** Path part for operation `mgmtOrdersToShipControllerValidate()` */
  static readonly MgmtOrdersToShipControllerValidatePath = '/api/mgmt-orders/to-ship/validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtOrdersToShipControllerValidate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mgmtOrdersToShipControllerValidate$Response(params: MgmtOrdersToShipControllerValidate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mgmtOrdersToShipControllerValidate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtOrdersToShipControllerValidate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mgmtOrdersToShipControllerValidate(params: MgmtOrdersToShipControllerValidate$Params, context?: HttpContext): Observable<void> {
    const resp = this.mgmtOrdersToShipControllerValidate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtOrdersShippedControllerShipping()` */
  static readonly GetManyBaseMgmtOrdersShippedControllerShippingPath = '/api/mgmt-orders/shipped';

  /**
   * Retrieve multiple Shippings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtOrdersShippedControllerShipping()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrdersShippedControllerShipping$Response(params?: GetManyBaseMgmtOrdersShippedControllerShipping$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShippingResponseDto>> {
    const obs = getManyBaseMgmtOrdersShippedControllerShipping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Shippings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtOrdersShippedControllerShipping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrdersShippedControllerShipping(params?: GetManyBaseMgmtOrdersShippedControllerShipping$Params, context?: HttpContext): Observable<GetManyShippingResponseDto> {
    const resp = this.getManyBaseMgmtOrdersShippedControllerShipping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShippingResponseDto>): GetManyShippingResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtOrdersShippedControllerShipping()` */
  static readonly GetOneBaseMgmtOrdersShippedControllerShippingPath = '/api/mgmt-orders/shipped/{id}';

  /**
   * Retrieve a single Shipping.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtOrdersShippedControllerShipping()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrdersShippedControllerShipping$Response(params: GetOneBaseMgmtOrdersShippedControllerShipping$Params, context?: HttpContext): Observable<StrictHttpResponse<Shipping>> {
    const obs = getOneBaseMgmtOrdersShippedControllerShipping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Shipping.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtOrdersShippedControllerShipping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrdersShippedControllerShipping(params: GetOneBaseMgmtOrdersShippedControllerShipping$Params, context?: HttpContext): Observable<Shipping> {
    const resp = this.getOneBaseMgmtOrdersShippedControllerShipping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Shipping>): Shipping => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtOrderControllerOrder()` */
  static readonly GetManyBaseMgmtOrderControllerOrderPath = '/api/mgmt-orders';

  /**
   * Retrieve multiple Orders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtOrderControllerOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderControllerOrder$Response(params?: GetManyBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyOrderResponseDto>> {
    const obs = getManyBaseMgmtOrderControllerOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Orders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtOrderControllerOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtOrderControllerOrder(params?: GetManyBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<GetManyOrderResponseDto> {
    const resp = this.getManyBaseMgmtOrderControllerOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyOrderResponseDto>): GetManyOrderResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtOrderControllerOrder()` */
  static readonly GetOneBaseMgmtOrderControllerOrderPath = '/api/mgmt-orders/{id}';

  /**
   * Retrieve a single Order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtOrderControllerOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderControllerOrder$Response(params: GetOneBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
    const obs = getOneBaseMgmtOrderControllerOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtOrderControllerOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtOrderControllerOrder(params: GetOneBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<Order> {
    const resp = this.getOneBaseMgmtOrderControllerOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Order>): Order => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtOrderControllerOrder()` */
  static readonly UpdateOneBaseMgmtOrderControllerOrderPath = '/api/mgmt-orders/{id}';

  /**
   * Update a single Order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtOrderControllerOrder()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtOrderControllerOrder$Response(params: UpdateOneBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<Order>> {
    const obs = updateOneBaseMgmtOrderControllerOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single Order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtOrderControllerOrder$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtOrderControllerOrder(params: UpdateOneBaseMgmtOrderControllerOrder$Params, context?: HttpContext): Observable<Order> {
    const resp = this.updateOneBaseMgmtOrderControllerOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Order>): Order => r.body)
    );
  }

  /** Path part for operation `mgmtOrderPickupControllerFindPickupPoint()` */
  static readonly MgmtOrderPickupControllerFindPickupPointPath = '/api/mgmt-orders/{id}/pickup-point';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtOrderPickupControllerFindPickupPoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtOrderPickupControllerFindPickupPoint$Response(params: MgmtOrderPickupControllerFindPickupPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<PickupPointDto>> {
    const obs = mgmtOrderPickupControllerFindPickupPoint(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtOrderPickupControllerFindPickupPoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtOrderPickupControllerFindPickupPoint(params: MgmtOrderPickupControllerFindPickupPoint$Params, context?: HttpContext): Observable<PickupPointDto> {
    const resp = this.mgmtOrderPickupControllerFindPickupPoint$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PickupPointDto>): PickupPointDto => r.body)
    );
  }

}
